import { Component } from 'react'
import DOMPurify from 'dompurify'

import * as h from 'h'

export default class Raw extends Component {
  static defaultProps = {
    element: 'div',
    defaultContent: ''
  };

  trim (content) {
    let trimmed = content.trim()

    const emptyParagraph = '<p>&nbsp;</p>'

    if (content.endsWith(emptyParagraph)) {
      trimmed = content.slice(0, -emptyParagraph.length)
    }

    return trimmed === content
      ? trimmed
      : this.trim(trimmed)
  }

  trimContent (content, defaultContent) {
    const raw = typeof content === 'string' ? content : defaultContent
    return this.trim(raw) || this.trim(defaultContent)
  }

  render () {
    const { element, content, defaultContent } = this.props

    const elementProps = Object.keys(this.props).reduce((acc, k) => {
      if (k === 'element' || k === 'content' || k === 'defaultContent') {
        return acc
      }
      acc[k] = this.props[k]
      return acc
    }, {})

    return h.h(element, {
      ...elementProps,
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(this.trimContent(content, defaultContent), {
          // dompurify strips the target attribute by default
          ADD_ATTR: ['target']
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Raw/index.js